
export interface AdvancedMetricDefinition {
    /** Идентификатор метрики, например 'm.PV' */
    metric: string;

    /** Выражение для вычисления текущего значения метрики */
    value: string;

    /** Выражение для максимального значения (опционально) */
    max?: string;

    /** Название метрики */
    title?: string;

    /** Цвет прогресс-бара */
    color?: string;

    /** Цвет фона */
    bgColor?: string;

    /** Цвет завершённого прогресса */
    colorDone?: string;

    /** Штриховка */
    striped?: boolean;

    /** Лейбл как процент */
    labelIsPercent?: boolean;

    /** Скруглённость */
    rounded?: boolean;

    /** Размер полосы ( */
    size?: number;

    /** CSS класс заголовка */
    titleClass?: string;

    /** CSS класс лейбла */
    labelClass?: string;

    /** Тип метрики */
    type?: string;
}

export interface AdvancedRankLevel {
    /** Уникальный ID ранга */
    id: number;

    /** Название ранга */
    title: string;

    /** Условия для достижения ранга (выражения) */
    levels: Record<string, string>;

    /** ID следующего ранга */
    nextRank?: number;


    /** Описание, которое будет отрендерено в HTML */
    description?: string;
}

export interface AdvancedRankProgressProps {
    id?: string;
    treeId?: number;
    title?: string;
    dataItem?: Record<string, { raw: number | string }>;

    /** Определения метрик, с выражениями */
    metrics: AdvancedMetricDefinition[];

    /** Определения рангов, с условиями в виде выражений */
    ranks: AdvancedRankLevel[];


    /** Шаблон заголовка «Следующий ранг» */
    nextRankTemplate?: string;

    /** Шаблон заголовка «Текущий ранг» */
    earnedRankTemplate?: string;

    /** Отображение по умолчанию (цвета и стили) */
    styleDefaults?: Partial<AdvancedMetricDefinition>;
}

export const advancedDefaults = {
    title: 'Rank Progress',
    treeId: 0,
    metrics: [] as AdvancedMetricDefinition[],
    ranks: [] as AdvancedRankLevel[],
    nextRankTemplate: undefined,
    earnedRankTemplate:undefined,
    styleDefaults: {
        color: '#64E479',
        bgColor: 'rgb(211, 203, 203)',
        colorDone: 'green',
        size: 30,
        titleClass: 'ml-4',
        labelClass: 'mr-4',
    },
};
function sanitizeKey(key: string): string {
    // parent-profile → parentProfile
    const noDashes = key.replace(/-([a-z])/g, (_, char) => char.toUpperCase());

    // parentProfile.title → parentProfile_title
    return noDashes.replace(/\./g, '_');
}
export function evaluateExpression(expr: string | number, context: Record<string, number>): number {
    try {
        const originalExpr = String(expr);

        // 1. Преобразуем выражение
        const safeExpr = originalExpr.replace(/\b[mp]\.[a-zA-Z0-9_.-]+/g, (match) =>
            sanitizeKey(match)
        );

        const safeContext: Record<string, number> = {};
        for (const key in context) {
            const safeKey = sanitizeKey(key);

            // check name validity
            if (!/^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(safeKey)) {
                continue;
            }

            safeContext[safeKey] = context[key];
        }

        const keys = Object.keys(safeContext);
        const values = keys.map((k) => safeContext[k]);

        const fn = new Function(...keys, `return (${safeExpr});`);
        return Number(fn(...values));
    } catch (err) {
        console.error('[evaluateExpression] Error:', expr, err);
        return NaN;
    }
}




export function extractMetricNames(expr: string): string[] {
    const regex = /\b[mp]\.[a-zA-Z0-9_]+/g;
    const matches = expr.match(regex);
    return matches ? Array.from(new Set(matches)) : [];
}
